var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDecentralized = function SvgDecentralized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 464 628"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M396.04 321.143c-1.054 0-2.054-.211-2.827-.668l-63.535-36.674c-.825-.474-1.264-1.159-1.264-1.914 0-.877.615-1.738 1.703-2.352l62.675-36.183c1.913-1.106 4.74-1.211 6.408-.246l63.535 36.675c.825.474 1.264 1.158 1.264 1.913 0 .878-.615 1.738-1.703 2.353l-62.675 36.183c-1.036.614-2.335.913-3.581.913m-2.335-1.51c1.351.79 3.844.667 5.424-.246l62.675-36.183c.755-.439 1.212-1.001 1.212-1.51s-.422-.86-.773-1.053l-63.535-36.674c-1.352-.79-3.845-.668-5.425.245l-62.674 36.183c-.755.439-1.212 1.001-1.212 1.51s.422.86.773 1.053z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__a)",
    d: "M464 261.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__b)",
    d: "M464 261.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__c)",
    d: "m396 300.515-68-39.257L396 222l68 39.258z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m396 299.598-67.2-38.803-.8.463 68 39.257 68-39.257-.8-.455z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m396.004 291.465-52.299-30.199 52.299-30.191 52.298 30.191z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__d)",
    d: "m396.002 291.465-52.299-30.199 52.299-30.19 52.298 30.19z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__e)",
    d: "m396.002 223.456 52.299 30.199v7.611l-52.299-30.199z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__f)",
    d: "m396.002 231.067-52.299 30.199v-7.611l52.299-30.199z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__g)",
    d: "m396.002 283.846-52.299-30.191 52.299-30.199 52.298 30.199z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.001 265.72-20.896-12.065 20.896-12.064 20.896 12.064z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.001 242.694 19.936 11.517.96-.556-20.896-12.064-20.896 12.064.96.556z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__h)",
    d: "M396.002 283.846v7.619l52.299-30.199v-7.611z",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__i)",
    d: "M343.703 253.655v7.611l52.299 30.199v-7.619z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m396.004 283.021-51.583-29.787-.716.421 52.299 30.191 52.298-30.191-.715-.421z",
    opacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M68.04 321.143c-1.054 0-2.054-.211-2.827-.668L1.678 283.801c-.825-.474-1.264-1.159-1.264-1.914 0-.877.615-1.738 1.703-2.352l62.675-36.183c1.913-1.106 4.74-1.211 6.408-.246l63.535 36.675c.825.474 1.264 1.158 1.264 1.913 0 .878-.615 1.738-1.703 2.353L71.621 320.23c-1.036.614-2.335.913-3.581.913m-2.335-1.51c1.352.79 3.844.667 5.424-.246l62.675-36.183c.755-.439 1.212-1.001 1.212-1.51s-.422-.86-.773-1.053l-63.535-36.674c-1.352-.79-3.845-.668-5.425.245L2.61 280.395c-.755.439-1.212 1.001-1.212 1.51s.422.86.773 1.053z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__j)",
    d: "M136 261.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__k)",
    d: "M136 261.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__l)",
    d: "M68 300.515 0 261.258 68 222l68 39.258z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 299.598.8 260.795l-.8.463 68 39.257 68-39.257-.8-.455z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m68.004 291.465-52.299-30.199 52.299-30.191 52.298 30.191z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__m)",
    d: "m68.002 291.465-52.299-30.199 52.299-30.19 52.298 30.19z",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__n)",
    d: "m68.002 223.456 52.299 30.199v7.611l-52.299-30.199z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__o)",
    d: "m68.002 231.067-52.299 30.199v-7.611l52.299-30.199z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__p)",
    d: "m68.002 283.846-52.299-30.191 52.299-30.199 52.298 30.199z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m68.001 265.72-20.896-12.065 20.896-12.064 20.896 12.064z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m68.001 242.694 19.936 11.517.96-.556-20.896-12.064-20.896 12.064.96.556z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__q)",
    d: "M68.002 283.846v7.619l52.299-30.199v-7.611z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__r)",
    d: "M15.703 253.655v7.611l52.299 30.199v-7.619z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "M68.004 283.021 16.42 253.234l-.716.421 52.299 30.191 52.298-30.191-.715-.421-51.583 29.787z",
    opacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__s)",
    d: "M231.907 190.166 112 120.943 231.907 51.72l119.89 69.223z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__t)",
    d: "m231.907 183.934-109.093-62.991 109.093-62.99L341 120.942l-109.093 62.991z",
    opacity: 0.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M231.907 455.876 112 386.652l119.907-69.223 119.89 69.223z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__u)",
    d: "M351.796 387v171.777L231.906 628V456.223z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__v)",
    d: "M351.796 120.943v265.709l-119.89 69.223V190.166z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__w)",
    d: "M112 120.943v265.709l119.907 69.223V190.166z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__x)",
    d: "M112 382v181.277L231.907 628V451.223z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEE",
    d: "M120.129 138.569V377.4l103.65 59.848V198.417z",
    opacity: 0.51
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__y)",
    d: "M333.82 185.145v7.022l-83.935 48.455v-7.023z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__z)",
    d: "M333.82 214.833v7.022l-83.935 48.454v-7.022z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__A)",
    d: "M333.82 244.537v7.022l-83.935 48.455v-7.023z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__B)",
    d: "M333.82 274.224v7.023l-83.935 48.454v-7.022z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__C)",
    d: "M333.82 303.929v7.022l-83.935 48.454v-7.022z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__D)",
    d: "M333.82 333.616v7.022l-83.935 48.472v-7.04z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m231.907 187.919-117.958-68.1-1.949 1.124 119.907 69.223 119.89-69.223-1.931-1.124z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4B7CF",
    d: "m112 344.658 119.907-72.383v-82.109L112 120.943z",
    opacity: 0.51
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__E)",
    d: "M231.907 138.446 112 69.223 231.907 0l119.89 69.223z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__F)",
    d: "m231.908 119.538-87.166-50.315 87.166-50.315 87.165 50.315z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "m231.908 22.314 84.215 48.612 2.95-1.703-87.165-50.315-87.166 50.315 2.95 1.703z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__G)",
    d: "M351.796 69.223v39.237l-119.89 69.224v-39.238z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__H)",
    d: "M351.796 69.223v39.237l-119.89 69.224v-39.238z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A6E8D",
    d: "M112 69.223v39.237l119.907 69.224v-39.238z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#453C9E",
    d: "M120.129 86.85v12.359l103.65 59.848v-12.359l-103.65-59.849z",
    opacity: 0.51
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m231.907 136.199-117.958-68.1L112 69.224l119.907 69.223 119.89-69.223-1.931-1.123z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#453C9E",
    d: "M333.818 96.716v7.022l-83.935 48.455v-7.023z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__I)",
    d: "M333.818 96.716v7.022l-83.935 48.455v-7.023z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__J)",
    d: "M112 69.223v39.237l119.907 69.224v-39.238z",
    opacity: 0.51
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M196.902 137.007c0-.402-.214-.774-.562-.975l-19.456-11.239a1.13 1.13 0 1 0-1.129 1.956l19.459 11.232a1.125 1.125 0 0 0 1.688-.974m-24.843-14.313a1.12 1.12 0 0 0-.558-.968l-3.637-2.106a1.123 1.123 0 1 0-1.124 1.946l3.642 2.098a1.12 1.12 0 0 0 1.677-.97m-27.549-15.898a1.12 1.12 0 0 0-.561-.979l-9.802-5.658a1.117 1.117 0 0 0-1.118 1.936l9.798 5.664a1.122 1.122 0 0 0 1.683-.963m10.975 6.331c0-.4-.213-.769-.559-.969l-6.472-3.732a1.119 1.119 0 0 0-1.117 1.937l6.472 3.732a1.118 1.118 0 0 0 1.676-.968m8.166 4.708c0-.401-.215-.772-.563-.973l-3.641-2.098a1.119 1.119 0 0 0-1.119 1.938l3.636 2.106a1.124 1.124 0 0 0 1.687-.973m68.877-81.939c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.732l1.812-1.052a1 1 0 0 1 1.004 0l1.813 1.052a1 1 0 0 1-.003 1.732z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M240.145 40.285c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733l-1.806 1.04z",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M247.752 44.686a1 1 0 0 1-1.006 0l-1.802-1.052a1 1 0 0 1 .003-1.73l1.802-1.043a1 1 0 0 1 1 0l1.811 1.042a1 1 0 0 1 .003 1.732z",
    opacity: 0.4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M255.367 49.08a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M262.986 53.47a1 1 0 0 1-.998 0l-1.806-1.041a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z",
    opacity: 0.4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M270.606 57.874a1 1 0 0 1-1 0l-1.811-1.042a1 1 0 0 1-.003-1.732l1.811-1.051a1 1 0 0 1 1.006 0l1.803 1.052a1 1 0 0 1-.003 1.73zm7.601 4.391a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04a1 1 0 0 1 .998 0l1.806 1.04a1 1 0 0 1 0 1.733l-1.806 1.04zm7.624 4.402a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044a1 1 0 0 1 .998 0l1.813 1.044a1 1 0 0 1 .003 1.731z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M293.447 71.06a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M224.874 40.301a1 1 0 0 1-1 0l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1-.001l1.806 1.04a1 1 0 0 1 0 1.733zm7.621 4.404a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.732l1.812-1.044a1 1 0 0 1 .998 0l1.813 1.044a1 1 0 0 1 .003 1.732zm7.616 4.393a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733l-1.807 1.04zm7.62 4.389c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733l-1.806 1.04zm7.602 4.405a1 1 0 0 1-1 0l-1.802-1.044a1 1 0 0 1-.003-1.729l1.802-1.052a1 1 0 0 1 1.006 0l1.811 1.051a1 1 0 0 1-.003 1.731l-1.811 1.044zm7.618 4.39a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733zm7.623 4.403c-.311.18-.694.18-1.005 0l-1.812-1.053a1 1 0 0 1 .003-1.731l1.812-1.044c.309-.178.69-.178.999 0l1.812 1.044a1 1 0 0 1 .003 1.731zm7.618 4.391a1 1 0 0 1-1 .001l-1.805-1.04a1 1 0 0 1 0-1.733l1.805-1.04a1 1 0 0 1 1 .002l1.797 1.04a1 1 0 0 1 0 1.73zm7.602 4.404a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044a1 1 0 0 1 .998 0l1.812 1.044a1 1 0 0 1 .003 1.731zm-68.556-30.758c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044c.309-.178.69-.178.999 0l1.812 1.044a1 1 0 0 1 .003 1.731zm7.614 4.394c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.604 4.388a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1-.001l1.806 1.04a1 1 0 0 1 0 1.733z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M240.074 57.911a1 1 0 0 1-.998 0l-1.812-1.044a1 1 0 0 1-.003-1.731l1.812-1.052a1 1 0 0 1 1.004 0l1.813 1.052a1 1 0 0 1-.003 1.731z",
    opacity: 0.1
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M247.694 62.3c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.622 4.402c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044c.309-.178.69-.178.999 0l1.812 1.044a1 1 0 0 1 .003 1.731z",
    opacity: 0.4
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M262.917 71.095a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.73l1.796-1.04a1 1 0 0 1 1-.002l1.805 1.04a1 1 0 0 1 0 1.733zm7.621 4.403a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044a1 1 0 0 1 .998 0l1.813 1.043a1 1 0 0 1 .003 1.732zm7.617 4.393c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .999 0l1.806 1.04a1 1 0 0 1 0 1.733z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M209.583 49.132a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.73l1.796-1.04a1 1 0 0 1 1-.002l1.805 1.04a1 1 0 0 1 0 1.733zm7.618 4.39a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733l-1.807 1.04z",
    opacity: 0.4
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M224.821 57.928c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.73l1.812-1.053c.311-.18.694-.18 1.005 0l1.812 1.052a1 1 0 0 1-.003 1.731z",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M232.44 62.317c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.605 4.402a1 1 0 0 1-1.006-.001l-1.802-1.052a1 1 0 0 1 .003-1.729l1.802-1.043a1 1 0 0 1 1-.001l1.811 1.043a1 1 0 0 1 .003 1.732zm7.615 4.394a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M255.283 75.515c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044c.309-.178.69-.178.999 0l1.812 1.044a1 1 0 0 1 .003 1.73z",
    opacity: 0.4
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M262.901 79.907a1 1 0 0 1-1 0l-1.805-1.04a1 1 0 0 1 0-1.732l1.805-1.04a1 1 0 0 1 1 .001l1.797 1.04a1 1 0 0 1 0 1.73zm7.602 4.39a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1 0l1.805 1.039a1 1 0 0 1 0 1.733zM201.946 53.54c-.309.177-.69.177-.999 0l-1.806-1.041a1 1 0 0 1 0-1.733l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.617 4.406c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.731l1.812-1.052c.311-.18.694-.18 1.005 0l1.812 1.052a1 1 0 0 1-.003 1.731zm7.604 4.388a1 1 0 0 1-1 0l-1.796-1.04a1 1 0 0 1 0-1.732l1.796-1.04a1 1 0 0 1 1 0l1.805 1.04a1 1 0 0 1 0 1.732zm7.618 4.408a1 1 0 0 1-.998 0l-1.812-1.044a1 1 0 0 1-.003-1.732l1.812-1.052a1 1 0 0 1 1.004 0l1.813 1.052a1 1 0 0 1-.003 1.732zm7.62 4.388a1 1 0 0 1-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.622 4.403c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.732l1.812-1.043c.309-.178.69-.178.999 0l1.812 1.043a1 1 0 0 1 .003 1.732zm7.601 4.392a1 1 0 0 1-1 0l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1-.001l1.805 1.04a1 1 0 0 1 0 1.733l-1.805 1.04zm7.618 4.39a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.619 4.407a1 1 0 0 1-.998 0l-1.812-1.044a1 1 0 0 1-.003-1.731l1.812-1.053a1 1 0 0 1 1.004 0l1.813 1.053a1 1 0 0 1-.003 1.73zm-68.558-30.76a1 1 0 0 1-1 0l-1.814-1.045a1 1 0 0 1-.005-1.73l1.799-1.05a1 1 0 0 1 1.006 0l1.815 1.053a1 1 0 0 1-.001 1.73zm7.601 4.39a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M209.528 66.759c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.732l1.812-1.052c.311-.18.694-.18 1.005 0l1.812 1.053a1 1 0 0 1-.003 1.73z",
    opacity: 0.4
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M217.147 71.148c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M224.752 75.55a1 1 0 0 1-1.006-.001l-1.802-1.052a1 1 0 0 1 .003-1.729l1.802-1.043a1 1 0 0 1 1-.001l1.811 1.043a1 1 0 0 1 .003 1.731z",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M232.367 79.943a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733zm7.619 4.389a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733zm7.622 4.407c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.731l1.812-1.053c.311-.18.694-.18 1.005 0l1.812 1.053a1 1 0 0 1-.003 1.731zm7.602 4.388a1 1 0 0 1-1 0l-1.796-1.04a1 1 0 0 1 0-1.732l1.796-1.04a1 1 0 0 1 1 0l1.805 1.04a1 1 0 0 1 0 1.732zM186.655 62.37c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .999 0l1.806 1.04a1 1 0 0 1 0 1.733zm7.617 4.407c-.309.178-.69.178-.999 0l-1.812-1.044a1 1 0 0 1-.003-1.732l1.812-1.052c.311-.18.694-.18 1.005 0l1.812 1.052a1 1 0 0 1-.003 1.732z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M201.876 71.165a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1 0l1.805 1.039a1 1 0 0 1 0 1.733z",
    opacity: 0.4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M209.497 75.568a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.732l1.812-1.043a1 1 0 0 1 .998 0l1.813 1.043a1 1 0 0 1 .003 1.732zm7.616 4.393a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M224.733 84.35c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.734z",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M232.337 88.756a1 1 0 0 1-1-.001l-1.802-1.043a1 1 0 0 1-.003-1.73l1.802-1.051a1 1 0 0 1 1.006-.001l1.811 1.051a1 1 0 0 1-.003 1.732z",
    opacity: 0.4
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M239.955 93.146a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04a1 1 0 0 1 .998 0l1.806 1.04a1 1 0 0 1 0 1.733z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M247.577 97.548a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044a1 1 0 0 1 .998 0l1.813 1.044a1 1 0 0 1 .003 1.731z",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M179.016 66.793a1 1 0 0 1-1 0l-1.811-1.043a1 1 0 0 1-.003-1.73l1.811-1.052a1 1 0 0 1 1.006 0l1.803 1.052a1 1 0 0 1-.003 1.73z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M186.617 71.183a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z",
    opacity: 0.4
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M194.239 75.586a1 1 0 0 1-1.004 0l-1.812-1.053a1 1 0 0 1 .003-1.73l1.812-1.045a1 1 0 0 1 .998 0l1.813 1.044a1 1 0 0 1 .003 1.731zm7.617 4.393c-.309.178-.69.178-.999 0l-1.806-1.04a1 1 0 0 1 0-1.734l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.734zm7.602 4.388a1 1 0 0 1-1 0l-1.796-1.04a1 1 0 0 1 0-1.731l1.796-1.04a1 1 0 0 1 1-.001l1.805 1.04a1 1 0 0 1 0 1.733l-1.805 1.04zm7.618 4.407a1 1 0 0 1-.998 0l-1.812-1.044a1 1 0 0 1-.003-1.73l1.812-1.053a1 1 0 0 1 1.004 0l1.813 1.052a1 1 0 0 1-.003 1.731zm7.619 4.389a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M232.32 97.566c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.732l1.812-1.043c.309-.178.69-.178.999 0l1.812 1.043a1 1 0 0 1 .003 1.732z",
    opacity: 0.4
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M239.919 101.958a1 1 0 0 1-1-.001l-1.796-1.04a1 1 0 0 1 0-1.73l1.796-1.04a1 1 0 0 1 1-.001l1.805 1.04a1 1 0 0 1 0 1.732zM171.361 71.2a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M178.982 75.603c-.311.18-.694.18-1.005 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044c.309-.178.69-.178.999 0l1.812 1.044a1 1 0 0 1 .003 1.731z",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M186.6 79.995a1 1 0 0 1-1 0l-1.805-1.04a1 1 0 0 1 0-1.732l1.805-1.04a1 1 0 0 1 1 .001l1.797 1.04a1 1 0 0 1 0 1.73zm7.601 4.39a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733zm7.619 4.407a1 1 0 0 1-.998 0l-1.812-1.044a1 1 0 0 1-.003-1.731l1.812-1.053a1 1 0 0 1 1.004 0l1.813 1.053a1 1 0 0 1-.003 1.731zm7.62 4.388a1 1 0 0 1-.999 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04c.309-.178.69-.178.999 0l1.806 1.04a1 1 0 0 1 0 1.733z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M217.047 97.583a1 1 0 0 1-1.006-.001l-1.802-1.052a1 1 0 0 1 .003-1.73l1.802-1.043a1 1 0 0 1 1 0l1.811 1.043a1 1 0 0 1 .003 1.731z",
    opacity: 0.4
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M224.662 101.976a1 1 0 0 1-.998 0l-1.806-1.04a1 1 0 0 1 0-1.733l1.806-1.04a1 1 0 0 1 .998 0l1.807 1.04a1 1 0 0 1 0 1.733zm7.622 4.403a1 1 0 0 1-1.004 0l-1.812-1.052a1 1 0 0 1 .003-1.731l1.812-1.044a1 1 0 0 1 .998 0l1.813 1.044a1 1 0 0 1 .003 1.731z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M396.04 506.143c-1.054 0-2.054-.211-2.827-.667l-63.535-36.675c-.825-.474-1.264-1.159-1.264-1.913 0-.878.615-1.739 1.703-2.353l62.675-36.183c1.913-1.106 4.74-1.211 6.408-.246l63.535 36.675c.825.474 1.264 1.159 1.264 1.913 0 .878-.615 1.738-1.703 2.353l-62.675 36.183c-1.036.614-2.335.913-3.581.913m-2.335-1.51c1.351.79 3.844.667 5.424-.246l62.675-36.183c.755-.439 1.212-1 1.212-1.51 0-.509-.422-.86-.773-1.053l-63.535-36.674c-1.352-.79-3.845-.667-5.425.245l-62.674 36.183c-.755.439-1.212 1.001-1.212 1.51s.422.86.773 1.053z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__K)",
    d: "M464 446.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__L)",
    d: "M464 446.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__M)",
    d: "m396 485.515-68-39.257L396 407l68 39.258z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m396 484.598-67.2-38.803-.8.463 68 39.257 68-39.257-.8-.455z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m396.004 476.465-52.299-30.199 52.299-30.19 52.298 30.19z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__N)",
    d: "m396.002 476.465-52.299-30.199 52.299-30.19 52.298 30.19z",
    opacity: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__O)",
    d: "m396.002 408.456 52.299 30.199v7.611l-52.299-30.199z",
    opacity: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__P)",
    d: "m396.002 416.067-52.299 30.199v-7.611l52.299-30.199z",
    opacity: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__Q)",
    d: "m396.002 468.846-52.299-30.191 52.299-30.199 52.298 30.199z",
    opacity: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.001 450.72-20.896-12.065 20.896-12.064 20.896 12.064z",
    opacity: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.001 427.694 19.936 11.517.96-.556-20.896-12.064-20.896 12.064.96.556z",
    opacity: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__R)",
    d: "M396.002 468.846v7.619l52.299-30.199v-7.611z",
    opacity: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__S)",
    d: "M343.703 438.655v7.611l52.299 30.199v-7.619z",
    opacity: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m396.004 468.021-51.583-29.787-.716.421 52.299 30.191 52.298-30.191-.715-.421z",
    opacity: 0.8
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M68.04 506.143c-1.054 0-2.054-.211-2.827-.667L1.678 468.801c-.825-.474-1.264-1.159-1.264-1.913 0-.878.615-1.739 1.703-2.353l62.675-36.183c1.913-1.106 4.74-1.211 6.408-.246l63.535 36.675c.825.474 1.264 1.159 1.264 1.913 0 .878-.615 1.738-1.703 2.353L71.621 505.23c-1.036.614-2.335.913-3.581.913m-2.335-1.51c1.352.79 3.844.667 5.424-.246l62.675-36.183c.755-.439 1.212-1 1.212-1.51 0-.509-.422-.86-.773-1.053l-63.535-36.674c-1.352-.79-3.845-.667-5.425.245L2.61 465.395c-.755.439-1.212 1.001-1.212 1.51s.422.86.773 1.053z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__T)",
    d: "M136 446.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__U)",
    d: "M136 446.258v7.854l-68 39.267-68-39.267v-7.854z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__V)",
    d: "M68 485.515 0 446.258 68 407l68 39.258z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 484.598.8 445.795l-.8.463 68 39.257 68-39.257-.8-.455z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m68.004 476.465-52.299-30.199 52.299-30.19 52.298 30.19z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__W)",
    d: "m68.002 476.465-52.299-30.199 52.299-30.19 52.298 30.19z",
    opacity: 0.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__X)",
    d: "m68.002 408.456 52.299 30.199v7.611l-52.299-30.199z",
    opacity: 0.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__Y)",
    d: "m68.002 416.067-52.299 30.199v-7.611l52.299-30.199z",
    opacity: 0.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__Z)",
    d: "m68.002 468.846-52.299-30.191 52.299-30.199 52.298 30.199z",
    opacity: 0.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m68.001 450.72-20.896-12.065 20.896-12.064 20.896 12.064z",
    opacity: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m68.001 427.694 19.936 11.517.96-.556-20.896-12.064-20.896 12.064.96.556z",
    opacity: 0.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__aa)",
    d: "M68.002 468.846v7.619l52.299-30.199v-7.611z",
    opacity: 0.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#decentralized_svg__ab)",
    d: "M15.703 438.655v7.611l52.299 30.199v-7.619z",
    opacity: 0.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "M68.004 468.021 16.42 438.234l-.716.421 52.299 30.191 52.298-30.191-.715-.421-51.583 29.787z",
    opacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__a",
    x1: 294.381,
    x2: 468.651,
    y1: 284.816,
    y2: 284.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__b",
    x1: 329.42,
    x2: 341.838,
    y1: 296.082,
    y2: 244.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__c",
    x1: 396,
    x2: 396,
    y1: 222,
    y2: 300.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__d",
    x1: 343.7,
    x2: 448.303,
    y1: 261.266,
    y2: 261.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__e",
    x1: 396,
    x2: 448.302,
    y1: 242.358,
    y2: 242.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__f",
    x1: 343.702,
    x2: 396.003,
    y1: 242.358,
    y2: 242.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__g",
    x1: 343.7,
    x2: 448.303,
    y1: 253.647,
    y2: 253.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__h",
    x1: 396,
    x2: 448.302,
    y1: 272.557,
    y2: 272.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__i",
    x1: 343.702,
    x2: 396.003,
    y1: 272.557,
    y2: 272.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__j",
    x1: -33.619,
    x2: 140.651,
    y1: 284.816,
    y2: 284.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__k",
    x1: 1.42,
    x2: 13.838,
    y1: 296.082,
    y2: 244.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__l",
    x1: 68,
    x2: 68,
    y1: 222,
    y2: 300.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__m",
    x1: 15.7,
    x2: 120.303,
    y1: 261.266,
    y2: 261.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__n",
    x1: 68,
    x2: 120.302,
    y1: 242.358,
    y2: 242.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__o",
    x1: 15.702,
    x2: 68.003,
    y1: 242.358,
    y2: 242.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__p",
    x1: 15.7,
    x2: 120.303,
    y1: 253.647,
    y2: 253.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__q",
    x1: 68,
    x2: 120.302,
    y1: 272.557,
    y2: 272.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__r",
    x1: 15.702,
    x2: 68.003,
    y1: 272.557,
    y2: 272.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__s",
    x1: 231.898,
    x2: 231.898,
    y1: 51.72,
    y2: 190.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8286A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9DB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__t",
    x1: 231.907,
    x2: 231.907,
    y1: 57.952,
    y2: 183.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__u",
    x1: 264.408,
    x2: 291.908,
    y1: 398,
    y2: 589.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__v",
    x1: 220.408,
    x2: 351.908,
    y1: 428.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6E8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__w",
    x1: 171.954,
    x2: 171.954,
    y1: 120.943,
    y2: 455.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F829D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9699AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__x",
    x1: 144.507,
    x2: 173.131,
    y1: 393.228,
    y2: 588.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__y",
    x1: 291.852,
    x2: 291.852,
    y1: 185.145,
    y2: 240.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__z",
    x1: 291.852,
    x2: 291.852,
    y1: 214.833,
    y2: 270.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__A",
    x1: 291.852,
    x2: 291.852,
    y1: 244.537,
    y2: 300.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__B",
    x1: 291.852,
    x2: 291.852,
    y1: 274.224,
    y2: 329.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__C",
    x1: 291.852,
    x2: 291.852,
    y1: 303.929,
    y2: 359.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__D",
    x1: 291.852,
    x2: 291.852,
    y1: 333.616,
    y2: 389.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__E",
    x1: 231.898,
    x2: 231.898,
    y2: 138.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8286A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A9DB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__F",
    x1: 231.908,
    x2: 231.908,
    y1: 18.908,
    y2: 119.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A4069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__G",
    x1: 291.855,
    x2: 291.855,
    y1: 153.457,
    y2: 71.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__H",
    x1: 220.408,
    x2: 236.708,
    y1: 168.819,
    y2: 58.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6E8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__I",
    x1: 291.85,
    x2: 291.85,
    y1: 96.716,
    y2: 152.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA3B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C8D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__J",
    x1: 171.954,
    x2: 171.954,
    y1: 69.223,
    y2: 177.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F829D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9699AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__K",
    x1: 294.381,
    x2: 468.651,
    y1: 469.816,
    y2: 469.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__L",
    x1: 329.42,
    x2: 341.838,
    y1: 481.082,
    y2: 429.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__M",
    x1: 396,
    x2: 396,
    y1: 407,
    y2: 485.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__N",
    x1: 343.7,
    x2: 448.303,
    y1: 446.266,
    y2: 446.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__O",
    x1: 396,
    x2: 448.302,
    y1: 427.359,
    y2: 427.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__P",
    x1: 343.702,
    x2: 396.003,
    y1: 427.359,
    y2: 427.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__Q",
    x1: 343.7,
    x2: 448.303,
    y1: 438.647,
    y2: 438.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__R",
    x1: 396,
    x2: 448.302,
    y1: 457.557,
    y2: 457.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__S",
    x1: 343.702,
    x2: 396.003,
    y1: 457.558,
    y2: 457.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__T",
    x1: -33.619,
    x2: 140.651,
    y1: 469.816,
    y2: 469.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__U",
    x1: 1.42,
    x2: 13.838,
    y1: 481.082,
    y2: 429.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__V",
    x1: 68,
    x2: 68,
    y1: 407,
    y2: 485.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__W",
    x1: 15.7,
    x2: 120.303,
    y1: 446.266,
    y2: 446.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__X",
    x1: 68,
    x2: 120.302,
    y1: 427.359,
    y2: 427.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__Y",
    x1: 15.702,
    x2: 68.003,
    y1: 427.359,
    y2: 427.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__Z",
    x1: 15.7,
    x2: 120.303,
    y1: 438.647,
    y2: 438.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__aa",
    x1: 68,
    x2: 120.302,
    y1: 457.557,
    y2: 457.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "decentralized_svg__ab",
    x1: 15.702,
    x2: 68.003,
    y1: 457.558,
    y2: 457.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })))));
};
export default SvgDecentralized;